module.exports = __webpack_public_path__ + "img/step1-mobile-en.95ae6d0c.webp";